import { MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const REGIONS = ["São Paulo Capital", "ABC", "Baixada", "Interior de São Paulo"];

export default function Regioes() {
  return (
    <section id="regioes" className="relative overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead index="05" label="Regiões atendidas" title="Onde a HidroPro Serviços Técnicos atende." />
        <div data-testid="hidropro-service-regions-pills" className="mt-10 flex flex-wrap gap-4 lg:mt-14">
          {REGIONS.map((region, i) => (
            <Reveal key={region} delay={i * 0.07}>
              <span className="group flex items-center gap-3 rounded-full border border-[rgba(10,92,140,0.3)] bg-white px-6 py-3.5 transition-all duration-300 hover:border-[#0A5C8C] hover:shadow-[0_12px_30px_rgba(10,92,140,0.16)] sm:px-8">
                <MapPin className="h-4 w-4 text-[#0A5C8C] transition-transform duration-300 group-hover:-translate-y-0.5" />
                <span className="font-display text-base font-bold tracking-tight text-[#1A1A1A] sm:text-lg">{region}</span>
              </span>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-8 font-mono text-xs uppercase tracking-[0.2em] text-[#0A5C8C]">Consulte a disponibilidade de atendimento para sua cidade ou região</p>
        </Reveal>
      </div>
    </section>
  );
}
